import { useTranslation } from "react-i18next";

import { Autocomplete } from "../../../Autocomplete";
import type { PropertyTableSelector } from "../../types/types";

interface UserSelectorProps extends PropertyTableSelector {}

export const UserSelector = ({ onSelected }: UserSelectorProps) => {
    const returnSelectedOption = (option: Record<string, string | number>) => {
        if (onSelected) {
            onSelected(option);
        }
    };

    const { t } = useTranslation();

    return (
        <div data-name="idm_user_selector">
            <Autocomplete
                readOnly={false}
                label={t("dataGroups.usersTable.placeholder")}
                displayValue="fullName"
                onSelectedOption={returnSelectedOption}
                datasource="users"
            />
        </div>
    );
};
